import { render, staticRenderFns } from "./BaseVPhoneNumbers.vue?vue&type=template&id=59c30b0a&"
import script from "./BaseVPhoneNumbers.vue?vue&type=script&lang=js&"
export * from "./BaseVPhoneNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports